module.exports = __webpack_public_path__ + "img/user_Logo.cc2255b8.svg";